<template>
    <window-portal :open="data.show" @close="data.show = false">
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center>
                <div>
                    <p style="font-size: 30px;">Vista previa de impresión de Comprobante Contable de Liquidación</p>
                </div>
            </center>
            <br />
            <center>
                <button class="btnclean" style="font-size: 18px;" @click="Print()">
                    Imprimir
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="Download()">
                    Descargar
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="sendMail()">
                    Enviar Correo
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="downLoadJSON()">
                    Descargar JSON
                </button>
            </center>
            <!-- {{ JSON.stringify(data) }} -->
            <center>
                <div v-if="loading">
                    <p>Cargando...</p>
                </div>
            </center>
        </div>
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center v-if="mailLabel">
                {{ mailLabel }}
            </center>
        </div>

        <div class="book"
            style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">

            <!--Configuración de la pagina-->
            <div class="page" ref="dataprint"
                style="position: relative; width: 1000px; min-height: 1294px; background: white; margin: 0 auto; margin-bottom: 20px;">

                <!-- Encabezado-->

                <!-- Configuración del contenido de la pagina -->
                <div class="subpage" style="height: 1000px; padding-top: 20px; overflow: hidden;">
                    <div style="margin-left: 80px; margin-right: 50px;">
                        <div style="width: 100%;">
                            <table style="font-size: 12px; border-collapse: collapse; width: 100% !important;">
                                <tr style="">
                                    <td colspan="5" style="text-align: center;"><h2>DOCUMENTO TRIBUTARIO ELECTRÓNICO</h2></td>
                                </tr>
                                <tr style="">
                                    <td colspan="5" style="text-align: center;"><h1>COMPROBANTE CONTABLE DE LIQUIDACIÓN</h1></td>
                                </tr>
                                <tr>
                                    <td colspan="5">
                                        <hr />
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        <b>Código Generación:</b>
                                    </td>
                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        {{ data.data.IdentificacionCodigoGeneracion }} 
                                    </td>

                                    <td rowspan="3" style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        <img ref="qrcode"/>
                                    </td>
                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        <b>Modelo de facturación:</b>
                                    </td>
                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        {{ data.data.IdentificacionTipoModelo == 1 ? "Previo" : "" }}
                                        {{ data.data.IdentificacionTipoModelo == 2 ? "Diferido" : "" }}
                                    </td>

                                </tr>
                                <tr>
                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        <b>Número de Control:</b>
                                    </td>
                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        {{ data.data.IdentificacionNumeroControl }}
                                    </td>

                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        <b>Tipo de Transmisión:</b>
                                    </td>
                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        {{ data.data.IdentificacionTipoOperacion ? 'NORMAL' : 'CONTINGENCIA' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        <b>Sello de recepción:</b>
                                    </td>
                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        {{ data.data.SelloRecibido }}
                                    </td>
                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        <b>Fecha y hora de generación:</b>
                                    </td>
                                    <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                        {{ `${data.data.IdentificacionFecEmi} ${data.data.IdentificacionHorEmi}` }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <br />
                        <div style="width: 100%;">
                            <table
                                style="width: 100% !important; font-size: 11px; margin-top: 40px;">
                                <tr>
                                    <td colspan="6" style="text-align: center;"><h2>AGENTE DE PERCEPTOR (Emisor)</h2></td>
                                </tr>

                                <div style="border-collapse: collapse; border: 1px solid black;">
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Nombre o Razón Social:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                            {{ data.data.EmisorNombre }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Nombre comercial:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.EmisorNombreComercial }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>NIT:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ applyNitMaskHandlingHomologationOutOfInput(data.data.EmisorNit) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>NRC:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                            {{ applyDUIMaskOutOfInput(data.data.EmisorNrc) }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Actividad Económica:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.EmisorDescActividad }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Dirección:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.EmisorDireccionComplemento }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Número de Teléfono:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                            {{ data.data.EmisorTelefono }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Correo Electrónico:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.EmisorCorreo }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Tipo de Establecimiento:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.EmisorTipoEstablecimiento === "01" ? "Sucursal Agencia" : "" }}
                                            {{ data.data.EmisorTipoEstablecimiento === "02" ? "Casa Matriz" : "" }}
                                            {{ data.data.EmisorTipoEstablecimiento === "04" ? "Bodega" : "" }}
                                            {{ data.data.EmisorTipoEstablecimiento === "07" ? "Predio y/o patio" : "" }}
                                            {{ data.data.EmisorTipoEstablecimiento === "20" ? "Otro" : "" }}
                                        </td>
                                    </tr>
                                </div>
                            </table>
                            <table
                                style="width: 100% !important; font-size: 11px; margin-top: 40px;">
                                <tr>
                                    <td colspan="6" style="text-align: center;"><h2>AFILIADO (Receptor)</h2></td>
                                </tr>

                                <div style="border-collapse: collapse; border: 1px solid black;">
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Nombre o Razón Social:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                            {{ data.data.ReceptorNombre }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>NIT:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ applyNitMaskHandlingHomologationOutOfInput(data.data.ReceptorNit) }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>NRC:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                            {{ applyDUIMaskOutOfInput(data.data.ReceptorNrc) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Actividad Económica:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.ReceptorDescActividad }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Nombre Comercial:</b>
                                        </td>
                                        <td colspan="3" style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.ReceptorNombreComercial }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Dirección:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.ReceptorDireccionComplemento }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Correo Electrónico:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.ReceptorCorreo }}
                                        </td>
                                    </tr>
                                </div>
                            </table>

                            <table
                                style="width: 100% !important; font-size: 11px; margin-top: 40px;">
                                <tr>
                                    <td colspan="6" style="text-align: center;"><h2>DOCUMENTO</h2></td>
                                </tr>

                                <div style="border-collapse: collapse; border: 1px solid black;">
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Fecha inicio del periodo de liquidación:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                            {{ data.data.CuerpoDocumentoDclPerLiqFeInicio }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Fecha fin del periodo de liquidación:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.CuerpoDocumentoDclPerLiqFeFin }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Valor de las operaciones a liquidar:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                            ${{ data.data.CuerpoDocumentoDclValorOperaciones }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Cantidad de documentos de liquidación:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.CuerpoDocumentoDclCantidadDoc }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Descripción del monto no sujeto a percepción:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.CuerpoDocumentoDclDescripSinPer }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Comisión:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            ${{ data.data.CuerpoDocumentoDclComision }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Valores no sujetos a perceción:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            ${{ data.data.CuerpoDocumentoDclMontoSinPer }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Porcentaje comisión:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            ${{ data.data.CuerpoDocumentoDclPorcentComision }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Subtotal:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            ${{ data.data.CuerpoDocumentoDclSubTotal }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>IVA de la comisión:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            ${{ data.data.CuerpoDocumentoDclIvaComision }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>IVA de las operaciones a liquidar:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            ${{ data.data.CuerpoDocumentoDclIva }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Valor liquido a pagar al afiliado:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            ${{ data.data.CuerpoDocumentoDclLiquidoPagar }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Montos sujetos a percepción sin IVA:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            ${{ data.data.CuerpoDocumentoDclMontoSujPer }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>IVA Percibido:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            ${{ data.data.CuerpoDocumentoDclIvaPercibido }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <!--td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Observaciones:</b>
                                        </td>
                                        <td colspan="2" style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.CuerpoDocumentoDclObservaciones }}
                                        </td-->
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Valor en letras:</b>
                                        </td>
                                        <td colspan="5" style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.CuerpoDocumentoDclTotalLetras }}
                                        </td>
                                    </tr>
                                </div>
                            </table>

                            <table
                                style="width: 100% !important; font-size: 11px; margin-top: 40px;">

                                <div style="border-collapse: collapse; border: 1px solid black;">
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Nombre del responsable de la liquidación:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.ExtensionNombEntrega }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            <b>Documento del responsable:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                            {{ data.data.ExtensionDocuEntrega }}
                                        </td>
                                    </tr>
                                </div>
                            </table>
                        </div>
                    </div>
                </div>

                <div v-html="footer" style="width: 100% !important;"></div>
            </div>
        </div>
    </window-portal>
</template>

<script>

import jsPDF from "jspdf"
import QRCode from 'qrcode';
//import html2canvas from "html2canvas"
import {numberToText} from '@/helpers/conveterNumberText.js'
import {
    applyDUIMaskOutOfInput,
    applyNitMaskHandlingHomologationOutOfInput
} from "../../helpers/masks"
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue"
export default {
    name: "PrintLiquidaciones",
    props: ['data'],
    components: { WindowPortal },
    data() {
        return {
            header: null,
            footer: null,
            loading: false,
            mailLabel: null,
        }
    },
    watch: {
        'data.show'(){
            this.$nextTick(() => {

                if(this.data.show){
                    const { IdentificacionAmbiente, IdentificacionCodigoGeneracion, IdentificacionFecEmi } = this.data.data;
    
                    const url = `https://admin.factura.gob.sv/consultaPublica?ambiente=${IdentificacionAmbiente}&codGen=${IdentificacionCodigoGeneracion}&fechaEmi=${IdentificacionFecEmi}`;
    
                    const opt = {
                        errorCorrectionLevel: 'H',
                        type: 'image/png',
                        quality: 0.3,
                        margin: 1,
                        color: {
                            dark:"#000000",
                            light:"#ffffff"
                        },
                        width: 100
                    }
    
                    QRCode.toDataURL(url, opt, ( error, url ) => {
                        if(error){
                            console.log('Error al generar código qr: ' + error.message);
                            throw error;
                        }
    
                        console.log();
                        this.$refs.qrcode.src = url;
                    })
                }
            })
        }
    },
    mounted() {
        //console.log(this.data);
    },
    methods: {
        GetnumberToText(number) {
            if(number) return numberToText(number)
            else return ''
        },
        applyDUIMaskOutOfInput(value){
            return applyDUIMaskOutOfInput(value);
        },
        applyNitMaskHandlingHomologationOutOfInput(value){
            return applyNitMaskHandlingHomologationOutOfInput(value);
        },

        async Print(){
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            })
            
            
            doc.deletePage(2)

            doc.autoPrint({variant: 'non-conform'});
            const blob = doc.output("bloburl")
            window.open(blob)

            this.loading = false
        },
        async downLoadJSON() {
            try {
                const aElement = document.createElement('a');
                aElement.setAttribute('download', this.data.data.ID_Invoice+ "_"+this.data.data.IdentificacionFecEmi.replaceAll("/","-") + "_"+this.data.data.ReceptorNombreComercial.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".json");
                const blob = new Blob([JSON.stringify(this.data.data.JsonMh)], { type: 'application/json' });
                const href = URL.createObjectURL(blob);
                aElement.href = href;
                aElement.click();
                URL.revokeObjectURL(href);
            } catch (error) {
                this.mailLabel = 'Ocurrió un error al descargar JSON';
                console.log(error);
            }
        },
        async sendMail() {
            try {
                this.loading = true
                this.mailLabel = null;
                this.mailLabel = 'Enviando...';
                var doc = new jsPDF('p', 'pt', 'letter')
                await doc.html(this.$refs.dataprint, {
                    callback: function(doc){
                        doc.output()
                    },
                    x: 0,
                    y: 0,
                    margin: [0, 0, 0, 0],
                    html2canvas:{ 
                        scale: 0.612,
                        useCORS: true,
                        logging: false,
                        allowTaint: true
                    },
                });

                doc.deletePage(2)

                const jsonMH = this.data.data.JsonMh.dteJson
                const ID_Invoice = this.data.data.ID_Invoice;

                const body = {
                    dtefilebuffer: new Buffer.from(doc.output('arraybuffer')),
                    dtejson: { ...jsonMH, ID_Invoice },
                    dtefilebufferfilename: this.data.data.ID_Invoice+ "_"+this.data.data.IdentificacionFecEmi.replaceAll("/","-") + "_"+this.data.data.ReceptorNombreComercial.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')
                };

                await this.$API.invoices.sendInvoiceMail(body);

                this.mailLabel = 'Se envió el correo correctamente';
                this.$emit('mailSent');
            } catch (error) {
                this.mailLabel = `Ocurrió el siguiente error al enviar el correo ${ error }`;
            } finally {
                this.loading = false
            }
        },
        async Download(){
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            });
            
            doc.deletePage(2)
            doc.save(this.data.data.ID_Invoice+ "_"+this.data.data.IdentificacionFecEmi.replaceAll("/","-") + ".pdf"); //Agregado por Juan 13082023

            this.loading = false
        },
    }
}
</script>

<style scoped>
.u-row .u-col-100 {
    width: 100% !important;
}

.btnclean {
    border-radius: 15px;
    border: 1px solid white;
    background-color: #F29D35 !important;
    color: white !important;
}

.btnclose {
    border-radius: 15px;
    border: 1px solid white;
    background-color: rgb(255, 38, 38) !important;
    color: white !important;

}

* {
    font-family: Arial, Helvetica, sans-serif !important;
}</style>
